import React from "react";
import "./new-arrivals.css";

export default function MaskItemNewArrivals() {
  const maskData = [
    { id: 1, img: "mask-new-arrivals.png" },
    { id: 2, img: "mask-new-arrivals.png" },
    { id: 3, img: "mask-new-arrivals.png" },
    { id: 4, img: "mask-new-arrivals.png" },
    { id: 5, img: "mask-new-arrivals.png" },
    { id: 6, img: "mask-new-arrivals.png" },
    { id: 7, img: "mask-new-arrivals.png" },
    { id: 8, img: "mask-new-arrivals.png" }
  ];

  const CreateMaskItem = () => {
    return maskData.map(item => {
      return (
        <div key={`mask-${item.id}`} className="col-md-3 col-sm-6 col-xs-12">
          <div className="product-item mb-20">
            <div className="product-img hover-1">
              <div>
                <img src={`/assets/img/sf/mask/${item.img}`} alt={item.img} />
                <div className="layout-loader">"Loading..."</div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return CreateMaskItem();
}
